<template>
  <div :class="{ hidden: hidden }" class="pagination-container">
    <el-pagination
      :background="true"
      :current-page.sync="currentPage"
      :page-size.sync="limit"
      :layout="layout"
      :page-sizes="pageSizes"
      :total="total"
      v-bind="$attrs"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { updateQuery } from "@/utils/index";

export default {
  name: "Pagination",
  props: {
    size: {
      type: Number,
      default: 100,
    },
    total: {
      type: Number,
      required: true,
    },
    hidden: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      limit: null,
      offset: 0,
      pageSizes: [20, 50, 100],
    };
  },
  computed: {
    currentPage: {
      get() {
        return this.offset / this.limit + 1;
      },
      set(val) {
        this.$emit("update:page", val);
      },
    },
    layout: {
      get() {
        if (!isFinite(this.total)) {
          return "sizes, prev, next, jumper";
        }
        return "total, sizes, prev, pager, next, jumper";
      },
    },
  },
  created() {
    const { limit, offset } = this.$route.query;
    if (limit) {
      this.limit = +limit;
    } else {
      if (this.size) {
        this.limit = this.size;
        updateQuery(this, { limit: this.size });
      }
    }
    if (offset) this.offset = +offset;
  },
  methods: {
    handleSizeChange(val) {
      updateQuery(this, { limit: val, offset: 0 });
    },
    handleCurrentChange(val) {
      updateQuery(this, { limit: this.limit, offset: this.limit * (val - 1) });
    },
  },
};
</script>

<style scoped>
.pagination-container {
  padding: 30px 0;
}
.pagination-container.hidden {
  display: none;
}
</style>
